module.exports = __webpack_public_path__ + "img/wrong-empty.44487d93.png";